import { render, staticRenderFns } from "./fenge.vue?vue&type=template&id=4b61844f&scoped=true&"
import script from "./fenge.vue?vue&type=script&lang=ts&"
export * from "./fenge.vue?vue&type=script&lang=ts&"
import style0 from "./fenge.vue?vue&type=style&index=0&id=4b61844f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b61844f",
  null
  
)

export default component.exports